/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import {SubscriptionDurationEnum} from "@shared/Subscription/SubscriptionDurationEnum"
import {cloneRawJSON} from "@/utils/helpers";

export function getYearlySubscriptionVariant(planRawJSON){
	let result = cloneRawJSON(planRawJSON)
	if(!result){
		return null
	}
	if(result.billingPeriod === SubscriptionDurationEnum.YEAR){
		return result
	}
	let yearlyPricing = result?.pricing?.yearly
	if(!yearlyPricing){
		return null
	}
	result.name = `${result.name} - Yearly`
	result.planId = yearlyPricing.planId
	result.billingPeriod = SubscriptionDurationEnum.YEAR
	result.price = yearlyPricing.price
	result.pricePerMonth = Math.floor(yearlyPricing.price / 12 * 100) / 100
	result.billingPeriodPerMonth = SubscriptionDurationEnum.MONTH
	result.billingNotePerMonth = "month (billed yearly)"
	result.currencyCode = yearlyPricing.currencyCode
	return result
}

export function getMonthlySubscriptionVariant(planRawJSON){
	let result = cloneRawJSON(planRawJSON)
	if(!result){
		return null
	}
	let monthlyPricing = result?.pricing?.monthly
	if(!monthlyPricing){
		return null
	}
	result.planId = monthlyPricing.planId
	result.billingPeriod = SubscriptionDurationEnum.MONTH
	result.price = monthlyPricing.price
	result.pricePerMonth = monthlyPricing.price
	result.billingNotePerMonth = "month"
	result.currencyCode = monthlyPricing.currencyCode
	return result
}

export function getSubscriptionVariantByPlanId(planRawJSON, planId){
	let rawSubscription = cloneRawJSON(planRawJSON)
	if(!rawSubscription){
		return rawSubscription
	}
	let yearlyPricing = rawSubscription?.pricing?.yearly
	let monthlyPricing = rawSubscription?.pricing?.monthly
	let result = null
	if(yearlyPricing && yearlyPricing.planId === planId){
		result = getYearlySubscriptionVariant(rawSubscription)
	} else if(monthlyPricing && monthlyPricing.planId === planId){
		result = getMonthlySubscriptionVariant(rawSubscription)
	}
	return result || rawSubscription
}
